import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { ResetState } from './+state/actions/reset-state';
import { DataCollectionFacadeService } from './services/data-collection-facade.service';

@Component({
    selector: 'data-collection-main',
    templateUrl: './data-collection.component.html',
    styleUrls: ['./data-collection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataCollectionComponent implements OnInit {
    constructor(
        private readonly dataCollectionFacadeService: DataCollectionFacadeService,
    ) { }

    public ngOnInit(): void {
        this.resetState();
    }

    @Dispatch()
    private resetState(): ResetState {
        return new ResetState();
    }
}
